import type { HostingControlPanelDeclaration, HostingControlPanelKind } from '@tosho/contracts';
import { HOSTING_PANELS } from './hosting-technology-catalogue';
import { HostingTechnologySelect } from './HostingTechnologySelect';

export function HostingControlPanelsFields({
  values,
  onChange,
}: {
  readonly values: readonly HostingControlPanelDeclaration[];
  readonly onChange: (values: readonly HostingControlPanelDeclaration[]) => void;
}): React.JSX.Element {
  const kinds = Object.keys(HOSTING_PANELS) as HostingControlPanelKind[];
  const summary = values
    .map(
      (panel) =>
        `${HOSTING_PANELS[panel.kind].name} ${panel.present === null ? 'inconnu' : panel.present ? 'présent' : 'absent'}`,
    )
    .join(', ');
  return (
    <div className="hosting-panels-fields">
      <HostingTechnologySelect
        label="Panneau de contrôle serveur"
        multiple
        options={kinds.map((kind) => ({ value: kind, ...HOSTING_PANELS[kind] }))}
        values={values.map((panel) => panel.kind)}
        onChange={(selected) =>
          onChange(
            kinds
              .filter((kind) => selected.includes(kind))
              .map(
                (kind) => values.find((panel) => panel.kind === kind) ?? { kind, present: true },
              ),
          )
        }
      />
      {values.length > 0 && (
        <details className="hosting-panels-fields__states">
          <summary>Présence déclarée : {summary}</summary>
          {values.map((panel) => (
            <fieldset key={panel.kind}>
              <legend>{HOSTING_PANELS[panel.kind].name}</legend>
              <div className="hosting-panels-fields__status-buttons">
                {[
                  { name: 'Inconnu', value: null },
                  { name: 'Présent', value: true },
                  { name: 'Absent', value: false },
                ].map((state) => (
                  <button
                    key={state.name}
                    type="button"
                    aria-label={`${HOSTING_PANELS[panel.kind].name} déclaré ${state.name.toLocaleLowerCase('fr-FR')}`}
                    aria-pressed={panel.present === state.value}
                    onClick={() =>
                      onChange(
                        values.map((item) =>
                          item.kind === panel.kind ? { ...item, present: state.value } : item,
                        ),
                      )
                    }
                  >
                    {state.name}
                  </button>
                ))}
              </div>
            </fieldset>
          ))}
        </details>
      )}
    </div>
  );
}
